import { z } from "zod";

const optionalText = (max: number) => z.string().trim().max(max).optional().nullable();

export const studentProfilePatchSchema = z.object({
    firstName: z.string().trim().min(1).max(100), lastName: z.string().trim().max(100), name: z.string().trim().min(1).max(200),
    qualification: z.string().trim().max(200), status: z.enum(["completed", "inprogress"]).nullable(),
    dateOfBirth: optionalText(10), college: optionalText(200), headline: z.string().trim().max(120), bio: z.string().trim().max(1200),
    location: z.string().trim().max(100), linkedinUrl: z.union([z.literal(""), z.string().url().max(500)]), careerAmbition: z.string().trim().max(600),
    skills: z.array(z.string().trim().min(1).max(80)).max(30), educationDetails: z.array(z.record(z.string(), z.unknown())).max(20),
    experienceDetails: z.array(z.record(z.string(), z.unknown())).max(30), certifications: z.array(z.record(z.string(), z.unknown())).max(30), updatedAt: z.unknown(),
}).strict();

export const studentPhotoPatchSchema = z.object({ photoURL: z.union([z.literal(""), z.string().url()]), photoPath: z.string().max(500).nullable(), photoRemoved: z.boolean(), updatedAt: z.unknown() }).strict();
export const authPasswordPatchSchema = z.object({ mustResetPassword: z.literal(false), passwordSetAt: z.unknown() }).strict();

export function validated<T>(schema: z.ZodType<T>, value: unknown): T {
    return schema.parse(value);
}
